import { jsx } from "react/jsx-runtime";
import { Routes, Route, Navigate } from "react-router";
const PrivateRoute = ({ auth, children, redirectTo }) => {
  if (!auth) {
    return /* @__PURE__ */ jsx(Routes, { children: /* @__PURE__ */ jsx(Route, { path: "*", element: /* @__PURE__ */ jsx(Navigate, { to: redirectTo, replace: true }) }) });
  }
  return children;
};
export {
  PrivateRoute
};
